/**
 * Build an outbound link to an external site (agent websites, sponsors, etc.).
 *
 * Every link that leaves agentmrr.com gets a `ref=agentmrr` attribution param
 * plus UTM tags so destinations can see traffic is coming from us. If the input
 * isn't a valid absolute URL we return it untouched rather than throwing.
 */
export function buildOutboundUrl(baseUrl: string, campaign: string): string {
	try {
		const url = new URL(baseUrl);
		url.searchParams.set("ref", "agentmrr");
		url.searchParams.set("utm_source", "agentmrr");
		url.searchParams.set("utm_medium", "referral");
		url.searchParams.set("utm_campaign", campaign);
		return url.toString();
	} catch {
		return baseUrl;
	}
}
